(function() {
  var $2a784d0ee940df9d$export$2e2bcd8739ae039 = (() => {
    if (!customElements.get("table-tabs")) customElements.define("table-tabs", class TableTabs extends HTMLElement {
      constructor() {
        super();
        this._onSummaryClick = this._onSummaryClick.bind(this);
        this._onKeyDown = this._onKeyDown.bind(this);
      }
      connectedCallback() {
        this._initializeTabs();
        this.addEventListener("click", this._onSummaryClick);
        this.addEventListener("keydown", this._onKeyDown);
      }
      _initializeTabs() {
        const allDetails = this.querySelectorAll("details.table-details");
        let foundFirst = false;
        for (const details of allDetails) {
          const summary = details.querySelector("summary");
          const hasTable = details.nextElementSibling?.querySelector("td");
          if (!foundFirst && hasTable) {
            details.setAttribute("open", "");
            summary?.setAttribute("aria-selected", "true");
            foundFirst = true;
          } else {
            details.removeAttribute("open");
            summary?.setAttribute("aria-selected", "false");
          }
        }
      }
      _getSummaries() {
        return [ ...this.querySelectorAll("details.table-details > summary") ];
      }
      async _activateTab(summary) {
        const nextDetails = summary.parentElement;
        const currentDetails = this.querySelector("details.table-details[open]");
        if (nextDetails === currentDetails) return;
        this._getSummaries().forEach(s => s.setAttribute("aria-selected", s === summary ? "true" : "false"));
        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (currentDetails) {
          const currentContent = currentDetails.nextElementSibling;
          if (!reducedMotion) await currentContent.animate([ {
            opacity: 1,
            transform: "translateY(0)"
          }, {
            opacity: 0,
            transform: "translateY(4px)"
          } ], {
            duration: 200,
            easing: "ease-out"
          }).finished;
          currentDetails.removeAttribute("open");
        }
        nextDetails.setAttribute("open", "");
        const nextContent = nextDetails.nextElementSibling;
        if (!reducedMotion) nextContent.animate([ {
          opacity: 0,
          transform: "translateY(4px)"
        }, {
          opacity: 1,
          transform: "translateY(0)"
        } ], {
          duration: 300,
          easing: "ease-in",
          fill: "both"
        });
      }
      async _onSummaryClick(event) {
        const summary = event.target.closest("summary");
        if (!summary) return;
        const nextDetails = summary.parentElement;
        const currentDetails = this.querySelector("details.table-details[open]");
        if (nextDetails === currentDetails) {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        await this._activateTab(summary);
      }
      _onKeyDown(event) {
        const summary = event.target.closest("summary");
        if (!summary) return;
        const summaries = this._getSummaries();
        const currentIndex = summaries.indexOf(summary);
        let targetIndex = -1;
        if (event.key === "ArrowRight") targetIndex = (currentIndex + 1) % summaries.length; else if (event.key === "ArrowLeft") targetIndex = (currentIndex - 1 + summaries.length) % summaries.length; else if (event.key === "Home") targetIndex = 0; else if (event.key === "End") targetIndex = summaries.length - 1; else return;
        event.preventDefault();
        summaries[targetIndex].focus();
        this._activateTab(summaries[targetIndex]);
      }
    });
  })();
})();